<template>
  <div class="staff-edit">
    <el-card>
      <div slot="header">
        <span>{{creatable ? '新增' : '编辑'}}员工</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="工号：" prop="id">
          <el-input :disabled="!creatable" v-model.number="form.id" maxlength="6" placeholder="工号"></el-input>
        </el-form-item>
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="form.name" maxlength="6" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input v-model="form.email" placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item label="手机：" prop="mobile">
          <el-input v-model="form.mobile" maxlength="11" placeholder="手机"></el-input>
        </el-form-item>
        <el-form-item label="座位：">
          <el-input v-model="form.seat" placeholder="座位"></el-input>
        </el-form-item>
        <el-form-item label="入职时间：">
          <el-date-picker
            v-model="form.indate"
            type="date"
            placeholder="请选择入职时间"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="部门：">
          <department-cascade v-model="department" placeholder="请选择部门"></department-cascade>
        </el-form-item>
        <el-form-item label="地点：">
          <el-radio-group v-model="form.area">
            <el-radio-button v-for="(item, index) in ['广州','上海', '北京']" :key="index" :label="item"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="职位：">
          <el-input v-model="form.zhiwei" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item label="级别：">
          <level-cascade v-model="form.level"></level-cascade>
        </el-form-item>
        <el-form-item label="生日：">
          <el-date-picker
            v-model="form.birth"
            type="date"
            placeholder="请选择生日"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="性别：">
          <el-radio-group v-model="form.gender">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="学历：">
          <el-input v-model="form.xueli" placeholder="请输入学历"></el-input>
        </el-form-item>
        <el-form-item label="学位：">
          <el-input v-model="form.xuewei" placeholder="请输入学位"></el-input>
        </el-form-item>
        <el-form-item label="学校：">
          <el-input v-model="form.xuexiao" placeholder="请输入学校"></el-input>
        </el-form-item>
        <el-form-item label="专业：">
          <el-input v-model="form.zhuanye" placeholder="请输入专业"></el-input>
        </el-form-item>
        <el-form-item label="紧急联系人：">
          <el-input v-model="form.emergency" placeholder="紧急联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="紧急联系人电话：">
          <el-input v-model="form.emergencyphone" placeholder="请输入紧急联系人电话"></el-input>
        </el-form-item>
        <el-form-item label="照片：">
          <el-upload
            action
            accept="image/*"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onChange"
          >
            <img v-if="form.photo" :src="form.photo">
            <i v-else class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit" :loading="loading">提交</el-button>
          <el-button @click="$router.push('/yuangong?active=1')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import DepartmentCascade from '@/components/service/department-cascade'
import LevelCascade from '@/components/service/level-cascade'
import http from '@/plugins/axios'

export default {
  components: { DepartmentCascade, LevelCascade },
  data () {
    return {
      loading: false,
      file: '',
      department: [],
      form: {
        id: '',
        name: '',
        email: '',
        mobile: '',
        indate: '',
        area: '',
        zhiwei: '',
        level: '',
        birth: '',
        xuewei: '',
        xueli: '',
        xuexiao: '',
        zhuanye: '',
        gender: '',
        photo: '',
        seat: ''
      },
      rules: {
        id: [
          { required: true, message: '请输入工号' },
          { type: 'number', message: '工号必须为数字' }
        ],
        name: [
          { required: true, message: '请输入姓名' },
          { min: 2, max: 6, message: '长度在 2 到 5 个字符' }
        ],
        email: [
          { required: true, message: '请输入邮箱' },
          { type: 'email', message: '请输入合法的邮箱' }
        ]
      }
    }
  },
  computed: {
    creatable () { return +this.$route.params.id === 0 }
  },
  beforeRouteEnter (to, from, next) {
    if (+to.params.id === 0) {
      next()
    } else {
      http.post('/yuangong/list2', {
        gong_id: to.params.id
      }).then(res => {
        next(vm => {
          const bean = res.data.yuangong_data[ 0 ]
          bean.id = +bean.id
          vm.form = bean
          vm.department = [ bean.jiagou_first, bean.jiagou_second, bean.jiagou_third, bean.jiagou_forth ].filter(x => x !== '-1')
        })
      })
    }
  },
  methods: {
    onChange (file) {
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('照片大小不能超过 2MB!')
      } else {
        this.file = file.raw
        this.form.photo = URL.createObjectURL(this.file)
      }
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = JSON.parse(JSON.stringify(this.form))
          params.first = this.department[ 0 ] || '-1'
          params.second = this.department[ 1 ] || '-1'
          params.third = this.department[ 2 ] || '-1'
          params.fourth = this.department[ 3 ] || '-1'
          params.photo = this.file
          const data = new FormData()
          Object.keys(params).forEach(key => {
            data.append(key, params[ key ])
          })
          data.append('isnew', this.creatable)
          this.$http.post('/yuangong/add2', data).then(res => {
            this.loading = false
            res.successful && this.$router.push('/yuangong?active=1')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.staff-edit {
  .el-form .el-form-item:nth-last-of-type(2) .el-form-item__content {
    line-height: initial;
  }
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: $color-theme;
    }
  }
  .el-icon-plus {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  img {
    width: 150px;
    height: 150px;
    object-fit: cover;
    display: block;
  }
  p {
    color: #999;
    margin-top: 4px;
  }
}
</style>
